import { Router } from '@angular/router';
import { NavigationService } from 'core/navigation.service';

/**
 * Go back to events management page
 */
export function goBackToEvents(campaignId: string, navigationService: NavigationService, router: Router) {
  const reversedHistory = navigationService.getHistory()
    .map(url => url)
    .filter(url => url.includes(`events/manage`))
    .reverse();

  if (reversedHistory.length === 0) {
    // No event page in history, go to default event list
    return router.navigateByUrl(`/events/manage?campaignId=${campaignId}`);
  } else {
    // Go back to latest event page query
    return navigationService.goBackTo(reversedHistory[0]);
  }
}
